(function(wnd) {
    function FonixReservation(params) {
        try {
            if (params) {
                this.setParams(params);
            }

            this.init();
        } catch (error) {
            console.error(error);
        }
    }

    FonixReservation.prototype = {
        containers: undefined,
        propertyId: undefined,
        expireTime: null,
        intervals: {
            countdown: undefined,
            statusCheck: undefined,
        },
        modalButton: undefined,
        countdownContainer: undefined,
        reservationStatus: 'opened',
        checking: false,
        countdownValues: {},
        init: function () {
            if (!this.propertyId) {
                return;
            }

            this.setElements();
            this.initStatusCheck();
            this.initCountdown();
            this.addDOMEvents();
        },
        setElements: function () {
            this.containers = $('[data-purpose="fonix-reservation-container"]');
            this.modalButton = $(document).find('[data-purpose="reservation-modal-btn"]');
            this.countdownContainer = $(document).find('[data-purpose="reservation-countdown-container"]');

            this.countdownFields = {
                day: this.countdownContainer.find('.value[data-type="day"]'),
                hour: this.countdownContainer.find('.value[data-type="hour"]'),
                min: this.countdownContainer.find('.value[data-type="min"]'),
                sec: this.countdownContainer.find('.value[data-type="sec"]'),
            }
        },
        addDOMEvents: function () {
            var _self = this;

            if (this.modalButton) {
                this.modalButton.on('click', function () {
                    $('[data-remodal-id="fonix-reservation-form"]').remodal().open()
                });
            }

            $(document).on('civishaz.sended_form', function (evt, data) {
                if (typeof data.type === 'undefined' || data.type !== 'fonixReservation') {
                    return;
                }
                
                _self.statusCheck();
            });

            $(document).on('closed', '.fonix-reservation-remodal', function () {
                $('#fonixReservationContainer').removeClass('success-sent');
            });

            $(window).on('scroll', _self.checkScrollPosition);
        },
        checkScrollPosition: function () {
            var openedReservationBarClass = 'opened-reservation-bar';
            if (window.innerWidth > 600) {
                $('body').removeClass(openedReservationBarClass);

                return;
            }

            var currentBottom = $(window).scrollTop() + window.innerHeight;
            var box = $('#fonixReservationBox');
            var border = box.offset().top + box.outerHeight(true);
            if (border <= currentBottom && !$('body').hasClass(openedReservationBarClass)) {
                $('body').addClass(openedReservationBarClass);
            } else if (border > currentBottom && $('body').hasClass(openedReservationBarClass)) {
                $('body').removeClass(openedReservationBarClass);
            }
        },
        initStatusCheck: function () {
            var _self = this;
            var statusCheck = function () {
                _self.statusCheck();
            }

            this.intervals.statusCheck = setInterval(statusCheck, 30000);
        },
        initCountdown: function () {
            if (!this.expireTime ||
                !this.countdownContainer ||
                this.countdownContainer.length === 0 ||
                'pending' !== this.reservationStatus
            ) {
                return;
            }

            var _self = this;
            var dayLength = 24 * 60 * 60 * 1000;
            var hourLength = 60 * 60 * 1000;
            var minLength = 60 * 1000;

            var updateCountdown = function () {
                if (null === _self.expireTime) {
                    _self.destroyCountdown();

                    return;
                }

                var expire = new Date(_self.expireTime).getTime();
                var timeRemaining = expire - Date.now();
                if (timeRemaining <= 0) {
                    _self.setExpireTime(null);
                    _self.handleStatusChange('opened');

                    return;
                }

                var days = Math.floor(timeRemaining / dayLength);
                var hours = Math.floor((timeRemaining % dayLength) / hourLength);
                var mins = Math.floor((timeRemaining % hourLength) / minLength);
                var secs = Math.floor((timeRemaining % minLength) / 1000);

                _self.countdownFields.day.html(days);
                _self.countdownFields.hour.html(hours);
                _self.countdownFields.min.html(mins);
                _self.countdownFields.sec.html(secs);
            }

            updateCountdown();
            this.intervals.countdown = setInterval(updateCountdown, 1000);
        },
        statusCheck: function () {
            if (this.checking) {
                return;
            }

            var _self = this;
            this.checking = true;
            $.ajax({
                url: ajax_controller + 'checkPropertyReservationStatus/' + _self.propertyId,
                dataType: 'json',
                type: 'GET',
                success: function (response) {
                    if (response.success) {
                        _self.setExpireTime(response.expireTime);
                        _self.handleStatusChange(response.status);
                    }
                },
                complete: function () {
                    setTimeout(function () {
                        _self.checking = false;
                    }, 200);
                }
            });
        },
        setParams: function (params) {
            if (params.propertyId) this.setPropertyId(params.propertyId);
            if (params.expireTime) this.setExpireTime(params.expireTime);
            if (params.reservationStatus) this.setReservationStatus(params.reservationStatus);
        },
        handleStatusChange: function (status) {
            if (status === this.reservationStatus) {
                return;
            }

            this.containers.removeClass(this.reservationStatus);
            this.setReservationStatus(status);
            if ('opened' === status) {
                this.containers.addClass('opened');
                this.modalButton.removeAttr('disabled');
                $('.gallery-section').removeClass('grayscaled');
                
                this.destroyCountdown();
            } else if ('pending' === status) {
                this.containers.addClass('pending');
                this.modalButton.attr('disabled', true);
                $('.gallery-section').addClass('grayscaled');

                this.initCountdown();
            } else if ('reserved' === status) {
                this.containers.addClass('reserved');
                this.modalButton.attr('disabled', true);
                $('.gallery-section').addClass('grayscaled');
                
                this.destroyCountdown();
                if (this.intervals.statusCheck) {
                    clearInterval(this.intervals.statusCheck);
                }
                
                this.containers.fadeOut(200);
            }
        },
        destroyCountdown: function () {
            if (this.intervals.countdown) {
                clearInterval(this.intervals.countdown);
            }
        },
        setPropertyId: function (propertyId) {
            this.propertyId = propertyId;
        },
        setExpireTime: function (expireTime) {
            this.expireTime = expireTime;
        },
        setReservationStatus: function (reservationStatus) {
            this.reservationStatus = reservationStatus;
        },
    };

    wnd.FonixReservation = FonixReservation;
})(window);